export default __webpack_public_path__ + "static/media/review-salary.f6d1089f.md";